import { render, staticRenderFns } from "./CRadioButton.vue?vue&type=template&id=5c4d89d4&"
import script from "./CRadioButton.vue?vue&type=script&lang=js&"
export * from "./CRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports